module.exports = __webpack_public_path__ + "img/cooperativeMedia6.403878a9.jpg";